import {
  APP_STORE_URL,
  buildInviteUrl,
  buildPlayStoreUrlWithInviteRef,
  PENDING_INVITE_REF_KEY,
} from '../constants/inviteLinks';

export function persistPendingInviteRef(ref: string): void {
  const code = ref.trim();
  if (!code || typeof window === 'undefined') return;
  try {
    localStorage.setItem(PENDING_INVITE_REF_KEY, code);
  } catch {
    /* private browsing */
  }
}

export function getPendingInviteRef(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return localStorage.getItem(PENDING_INVITE_REF_KEY)?.trim() || null;
  } catch {
    return null;
  }
}

export function clearPendingInviteRef(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.removeItem(PENDING_INVITE_REF_KEY);
  } catch {
    /* ignore */
  }
}

export function buildInviteShareMessage(ref: string, language: 'ar' | 'en'): string {
  const code = ref.trim();
  const url = buildInviteUrl(code);

  if (language === 'ar') {
    return (
      `مرحباً!\n\n` +
      `أدعوك للانضمام إلى مرافعة.\n\n` +
      `عن مرافعة: منصة مصرية لإدارة الممارسة القانونية — موكّلون، ملفات قانونية، أجندة ومواعيد، مكتبة قانونية، ودليل المحامي، من التطبيق أو الويب.\n\n` +
      `كود الدعوة: ${code}\n` +
      `رابط الانضمام: ${url}\n\n` +
      `إذا سجّلت بدون الرابط، أدخل كود الدعوة في خانة «الكود المرجعي» أثناء التسجيل.`
    );
  }

  return (
    `Hi!\n\n` +
    `I'd like to invite you to join Morafaa.\n\n` +
    `About Morafaa: an all-in-one legal practice platform for Egyptian lawyers — clients, cases, calendar, legal library, and Lawyer Guide, on mobile and web.\n\n` +
    `Invitation code: ${code}\n` +
    `Join here: ${url}\n\n` +
    `If you sign up without the link, enter the invitation code in the "Reference Code" field during registration.`
  );
}

export { buildInviteUrl, buildPlayStoreUrlWithInviteRef, APP_STORE_URL };
